const PRELAUNCH_BASE = "https://api.malidag.com/prelaunch-tokens/";

const normAddr = (v) => String(v || "").trim().toLowerCase();

// optional: clean links (avoid spaces)
const normUrl = (v) => String(v || "").trim();

export async function fetchPrelaunchTokens(chainId) {
  const url = chainId
    ? `${PRELAUNCH_BASE}?chainId=${Number(chainId)}`
    : PRELAUNCH_BASE;

  const res = await fetch(url);
  const data = await res.json();
  if (!res.ok) throw new Error(data?.error || "Failed to fetch prelaunch tokens");
  return Array.isArray(data) ? data : [];
}

export async function addPrelaunchToken(payload) {
  const res = await fetch(PRELAUNCH_BASE, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      ...payload,
      chainId: Number(payload.chainId),
      tokenAddress: normAddr(payload.tokenAddress),

      // ✅ new fields
      description: String(payload.description || ""),
      website: normUrl(payload.website || ""),
      twitter: normUrl(payload.twitter || ""),
      telegram: normUrl(payload.telegram || ""),
      discord: normUrl(payload.discord || ""),
    }),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data?.error || "Failed to add token");
  return data;
}

export async function removePrelaunchToken(chainId, tokenAddress) {
  const url = `${PRELAUNCH_BASE}${Number(chainId)}/${normAddr(tokenAddress)}`;
  const res = await fetch(url, { method: "DELETE" });
  const data = await res.json();
  if (!res.ok) throw new Error(data?.error || "Failed to remove token");
  return data;
}

// ✅ PATCH (update any fields)
export async function updatePrelaunchToken(chainId, tokenAddress, patchBody) {
  const url = `${PRELAUNCH_BASE}${Number(chainId)}/${normAddr(tokenAddress)}`;
  const res = await fetch(url, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      ...patchBody,

      // ✅ new fields
      description:
        patchBody.description === undefined ? undefined : String(patchBody.description || ""),
      website: patchBody.website === undefined ? undefined : normUrl(patchBody.website || ""),
      twitter: patchBody.twitter === undefined ? undefined : normUrl(patchBody.twitter || ""),
      telegram: patchBody.telegram === undefined ? undefined : normUrl(patchBody.telegram || ""),
      discord: patchBody.discord === undefined ? undefined : normUrl(patchBody.discord || ""),
    }),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data?.error || "Failed to update token");
  return data; // { ok:true, token:{...} }
}

// ✅ PATCH /live (quick toggle)
export async function setPrelaunchTokenLive(chainId, tokenAddress, isLive, liveDate) {
  const url = `${PRELAUNCH_BASE}${Number(chainId)}/${normAddr(tokenAddress)}/live`;
  const res = await fetch(url, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ isLive, liveDate }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data?.error || "Failed to update live status");
  return data; // { ok:true, modified:n }
}
